import { ProjectTypes } from "../../variables";

const TypeBubble = ({ type, clickable, onClick, active }) => {
  let boxClasses = ["border-2 px-3 py-1 rounded-full font-semibold"];

  const getStyling = (type) => {
    switch (type) {
      case ProjectTypes.WORK:
        if (active) {
          return "bg-lime-400 border-lime-400 text-white dark:bg-lime-500 dark:border-lime-500 ";
        } else {
          return "bg-lime-50 border-lime-300 text-lime-400 dark:bg-lime-600 dark:border-lime-500 dark:text-lime-50";
        }
      case ProjectTypes.SCHOOL:
        if (active) {
          return "bg-yellow-400 border-yellow-400 text-white dark:bg-yellow-500 dark:border-yellow-500";
        } else {
          return "bg-yellow-50 border-yellow-300 text-yellow-400 dark:bg-yellow-600 dark:border-yellow-500 dark:text-yellow-50";
        }
      case ProjectTypes.PERSONAL:
        
        if (active) {
          return "bg-cyan-400 border-cyan-400 text-white dark:bg-cyan-500 dark:border-cyan-500";
        } else {
          return "bg-cyan-50 border-cyan-300 text-cyan-400 dark:bg-cyan-600 dark:border-cyan-500 dark:text-cyan-50";
        }

        default:
          break;
    }
  };

  // Apply styling
  boxClasses.push(getStyling(type));

  return (
    <button
      onClick={clickable ? onClick : () => {}}
      className={boxClasses.join(" ")}
    >
      {type}
    </button>
  );
};

export default TypeBubble;
